module.exports = __webpack_public_path__ + "static/media/bellabyte-brinde-mousepad-768x591.718afca2.jpg";